import { useEffect, useState } from "react";
import { Booking } from "./bookingTypes";
import axios from "axios";


const useFetchBookingsByOrderNumber = (orderNumber: string) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [bookings, setBookings] = useState<Booking[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    
    useEffect(() => {
        const fetchBookings = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
            `${apiUrl}/Booking/getAllBookingsByOrderNumber`,
            {
                params: { orderNumber },
            }
            );
            const data = response.data as { data: Booking[] };
            console.log("Response data:", data.data);
            setBookings(data.data);
        } catch (error: any) {
            console.error("Error fetching bookings:", error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
        };
    
        fetchBookings();
    }, [apiUrl, orderNumber]);
    
    return { bookings, loading, error };
}

export default useFetchBookingsByOrderNumber;